import { createSlice } from '@reduxjs/toolkit';
import { AddCryoboxToStagingState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { addCryoboxToStagingThunk } from './thunks';

// Initial State
const initialState: AddCryoboxToStagingState = {
  errors: null,
  status: StoreStatus.IDLE,
  values: null,
  response: null,
};

// Slice
export const addCryoboxTostagingSlice = createSlice({
  name: 'shipment',
  initialState,
  reducers: {
    addCryoboxTostagingReset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(addCryoboxToStagingThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(addCryoboxToStagingThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
      state.values = null;
    });
    builder.addCase(addCryoboxToStagingThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { addCryoboxTostagingReset } = addCryoboxTostagingSlice.actions;
export * from './thunks';
export default addCryoboxTostagingSlice.reducer;
